import {
  Boxed,
  ValidationErrors
} from 'ngrx-forms';
import {
  checkIfControlIsAlreadyPresentByPropertyKey,
  getControlDefinitionByPropertyKey
} from '../helpers';
import {
  CONTROL_METADATA_KEY,
  VALIDATOR_KEY
} from '../metadata-keys';
import { DxFormControlDefinition } from '../interfaces';
import { all } from 'deepmerge';
import {
  addToMetadata,
  removeFromMetadata
} from '@digitaix/helpers';

export function BuildValidatorDecorator<
  T,
  V extends T | Boxed<T> | null | undefined
>(
  validator: (value: V) => ValidationErrors,
  defaultValidatorErrorTemplate: string,
): (
  validatorErrorTemplate?: string
) => (target: any, propertyKey: string) => any {
  return function(validatorErrorTemplate: string = defaultValidatorErrorTemplate) {
    return function(target: any, propertyKey: string) {
      if (
        !checkIfControlIsAlreadyPresentByPropertyKey(
          target,
          propertyKey
        )
      ) {
        throw new Error(
          `[BuildValidatorDecorator::${propertyKey}] Control definition for '${propertyKey}' is not set`
        );
      }
      const controlMetadata = getControlDefinitionByPropertyKey(
        target,
        propertyKey
      );
      addToMetadata(
        VALIDATOR_KEY,
        {
          controlId: controlMetadata.name,
          propertyKey,
          validator,
          validatorErrorTemplate,
          parameters: {},
        },
        target
      );
    };
  };
}

export function BuildValidatorWithComparandDecorator<
  T,
  V extends T | Boxed<T> = T,
  C = T
>(
  validator: (comparand: C) => (value: V) => ValidationErrors,
  defaultValidatorErrorTemplate: string,
): (
  comparand: C,
  validatorErrorTemplate?: string
) => (target: any, propertyKey: string) => any {
  return function(comparand: C, validatorErrorTemplate: string = defaultValidatorErrorTemplate) {
    return function(target: any, propertyKey: string) {
      if (
        !checkIfControlIsAlreadyPresentByPropertyKey(
          target,
          propertyKey
        )
      ) {
        throw new Error(
          `[BuildValidatorWithComparandDecorator::${propertyKey}] Control definition for '${propertyKey}' is not set`
        );
      }
      const controlMetadata = getControlDefinitionByPropertyKey(
        target,
        propertyKey
      );
      addToMetadata(
        VALIDATOR_KEY,
        {
          controlId: controlMetadata.name,
          propertyKey,
          validator: validator(comparand),
          validatorErrorTemplate,
          parameters: { comparand },
        },
        target
      );
    };
  };
}

export function UpdateControlMetadata(target: any, propertyKey: string, update: Partial<DxFormControlDefinition<any>>): void {

  if (
    !checkIfControlIsAlreadyPresentByPropertyKey(
      target,
      propertyKey
    )
  ) {
    throw new Error(
      `[UpdateControlMetadata::${propertyKey}] Control definition for '${propertyKey}' is not set`
    );
  }
  const controlMetadata = getControlDefinitionByPropertyKey(
    target,
    propertyKey
  );
  removeFromMetadata(
    CONTROL_METADATA_KEY,
    { name: controlMetadata.name },
    target,
    undefined,
    (a, b) => a.name === b.name
  );
  addToMetadata(
    CONTROL_METADATA_KEY,
    all([controlMetadata, update]),
    target
  );

}
